import { Component, OnInit } from '@angular/core';
import { Form, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';

@Component({
  selector: 'app-movimentacao-societaria-natureza-mudanca',
  templateUrl: './movimentacao-societaria-natureza-mudanca.component.html',
  styleUrls: ['./movimentacao-societaria-natureza-mudanca.component.scss']
})
export class MovimentacaoSocietariaNaturezaMudancaComponent implements OnInit {

  naturezaMudancaFilterForm!: FormGroup;
  naturezaMudancaLista: any[] = [];

  constructor(
    private fb: FormBuilder,
    private location: Location
  ) { }

  ngOnInit() {
    this.construirForm();
  }

  construirForm() {
    this.naturezaMudancaFilterForm = this.fb.group({
      naturezaMudanca: ['', Validators.required]
    })
  }

  save() {

  }

  voltar() {
    this.location.back();
  }

}
